query teacherPhoneNumber($userId: ID, $teamId: ID, $id: ID, $forCurrent: Boolean) {
  teacherPhoneNumber(userId: $userId, id: $id, teamId: $teamId, forCurrent: $forCurrent) {
    id
    displayName
    number
  }
}
